import { render, staticRenderFns } from "./DeleteRewardSuccess.vue?vue&type=template&id=350ee9a0&scoped=true"
import script from "./DeleteRewardSuccess.vue?vue&type=script&lang=js"
export * from "./DeleteRewardSuccess.vue?vue&type=script&lang=js"
import style0 from "./DeleteRewardSuccess.vue?vue&type=style&index=0&id=350ee9a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350ee9a0",
  null
  
)

export default component.exports